import $ from 'jquery'
import axios from 'axios'
import { createAlert } from 'dom/window'

// localStorage
export const storageAvailable = (type) => {
  try {
    var storage = window[type],
      x = '__storage_test__'
    storage.setItem(x, x)
    storage.removeItem(x)
    return true
  } catch (e) {
    return (
      e instanceof DOMException &&
      // everything except Firefox
      (e.code === 22 ||
        // Firefox
        e.code === 1014 ||
        // test name field too, because code might not be present
        // everything except Firefox
        e.name === 'QuotaExceededError' ||
        // Firefox
        e.name === 'NS_ERROR_DOM_QUOTA_REACHED') &&
      // acknowledge QuotaExceededError only if there's something already stored
      storage.length !== 0
    )
  }
}

// converters
export const convertToBoolean = (string) => {
  if (typeof string === 'boolean') return string
  if (typeof string === 'number') return Boolean(string)
  if (typeof string === 'string' && string.length === 1) return Boolean(Number(string))
  if (typeof string === 'string' && string.length !== 1) return string.toLowerCase() === 'true'
  return false
}

// Convert array to dropdown values
export const arrayToDropdown = (arr) => {
  return arr.map((item) => {
    return {
      label: item,
      value: item,
    }
  })
}

/**
 * @param {*} arr
 * @returns array of objects
 */
export const arrayToKeyValuePairForDropDown = (arr) => {
  return arr.map((item) => {
    return {
      label: item.label,
      value: item.id,
    }
  })
}

/**
 * @param {*} arr
 * @param {*} labelKey
 * @param {*} valueKey
 * @returns array of objects
 */
export const arrayOfObjectsForDropDown = (arr, labelKey) => {
  return arr.map((item) => {
    return {
      label: item[labelKey],
      value: item[labelKey],
    }
  })
}

// fetch
export const param = (a) => {
  var s = []
  var add = function (k, v) {
    v = typeof v === 'function' ? v() : v
    v = v === null ? '' : v === undefined ? '' : v
    s[s.length] = encodeURIComponent(k) + '=' + encodeURIComponent(v)
  }
  var buildParams = function (prefix, obj) {
    var i, len, key

    if (prefix) {
      if (Array.isArray(obj)) {
        for (i = 0, len = obj.length; i < len; i++) {
          buildParams(prefix + '[' + (typeof obj[i] === 'object' && obj[i] ? i : '') + ']', obj[i])
        }
      } else if (String(obj) === '[object Object]') {
        for (key in obj) {
          buildParams(prefix + '[' + key + ']', obj[key])
        }
      } else {
        add(prefix, obj)
      }
    } else if (Array.isArray(obj)) {
      for (i = 0, len = obj.length; i < len; i++) {
        add(obj[i].name, obj[i].value)
      }
    } else {
      for (key in obj) {
        buildParams(key, obj[key])
      }
    }
    return s
  }
  return buildParams('', a).join('&')
}
export const getFormData = (object) => {
  const formData = new FormData()
  Object.keys(object).forEach((key) => formData.append(key, object[key]))
  return formData
}
export const handleFetchErrors = (response) => {
  if (!response.ok) {
    throw Error(response.statusText)
  }
  return response
}
export const fetchJSONData = (url, config, data, callback) => {
  const defaultConfig = {
    method: 'POST',
    body: param(data), // body: getFormData(data),
    credentials: 'include',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
    },
  }
  fetch(url, {
    ...defaultConfig,
    ...config,
  })
    .then(handleFetchErrors)
    .catch((error) => console.error('Error:', error))
    .then((res) => res.json())
    .then(callback)
}

// axios
export const handleAuthenticationRequired = (message) => {
  $('#unauthorized-access-modal').modal('show')
}
export const handleErrorMessage = (message) => {
  if (
    message &&
    (message.toLowerCase() == 'authentication required' ||
      message.toLowerCase() == 'unauthorized access' ||
      message.toLowerCase() == 'access denied' ||
      message.toLowerCase() == 'access forbidden')
  ) {
    handleAuthenticationRequired(message)
    return true
  }
  if (message) {
    createAlert(
      {
        message: message,
      },
      'error'
    )
  }
  return false
}
export const handleAxiosErrors = (error) => {
  if (axios.isCancel(error)) {
    return
  }

  if (error.response) {
    // The request was made and the server responded with a status code
    // that falls out of the range of 2xx
    console.log(error.response.data)
    console.log(error.response.status)
    console.log(error.response.headers)
  } else if (error.request) {
    // The request was made but no response was received
    // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
    // http.ClientRequest in node.js
    console.log(error.message, error.request)
    if (handleErrorMessage(error.message)) return
  } else {
    // Something happened in setting up the request that triggered an Error
    console.log(error.message)
    if (handleErrorMessage(error.message)) return
  }

  if (typeof error.message != 'undefined') {
    createAlert({ message: error.message }, 'error')
  } else {
    createAlert({}, 'error')
  }
  // console.log(error.config);
}
export const axiosInstance = axios.create({})
axiosInstance.interceptors.response.use((response) => {
  if (response.data.errors) {
    throw response.data.errors[0]
  }
  return response
})

export const createAxiosCancellationToken = () => {
  return axios.CancelToken.source()
}

//Prepod
export const imageBaseUrl = 'https://assets.paramountliquor.com.au'

//Live
// export const imageBaseUrl = 'https://www.paramountliquor.com.au'
export const scrollToError = () => {
  setTimeout(() => {
    document.querySelectorAll('.field--alert')[0]?.parentElement.scrollIntoView({
      behavior: 'smooth',
      block: 'center',
      inline: 'nearest',
    })
  }, 500)
}
/**
 * description: This function is used to get the address component from the google address object
 * @param {*} key
 * @param {*} addressComponents
 * @param {*} value
 * @returns
 */

export const getAddressComponent = (key, addressComponents, value = 'long_name') => {
  let data = ''
  addressComponents.length > 0 &&
    addressComponents.forEach((address) => {
      if (address?.types && address.types.includes(key)) {
        data = address[value]
      }
    })
  return data
}

/**
 * description: This function is used to check if the address fields are empty
 * @param  {...any} args
 * @returns boolean
 */
export const checkIfAddressFieldIsNotEmpty = (...args) => {
  console.log('args', args)
  if (args.length > 0) {
    return args.some((arg) => arg === '')
  }
}
